

































import { Vue, Component } from 'vue-property-decorator';

import { StartGuideCardNeedHelp } from '@/models/start-guide';
import { Typography } from '@/components/atoms';
import NeedHelpItem from '@/components/molecules/NeedHelpItem/NeedHelpItem.vue';

@Component({
  components: { Typography, NeedHelpItem }
})
export default class StartGuideNeedHelp extends Vue {
  get tPrefix() {
    return 'home.needHelp';
  }

  get needHelp() {
    return this.$store.getters[
      'startGuide/getNeedHelp'
    ] as StartGuideCardNeedHelp[];
  }
}
